module.exports = __webpack_public_path__ + "img/quote.f88dd1b2.svg";